module.exports = __webpack_public_path__ + "static/media/desktop-list-sm.ea748009.png";


//////////////////
// WEBPACK FOOTER
// ./src/desktop-list-sm.png
// module id = 26
// module chunks = 0